export enum VirtualDataRoomPermissionType {
  NO_ACCESS = "NO_ACCESS",
  CAN_VIEW = "CAN_VIEW",
  CAN_EDIT = "CAN_EDIT",
  CAN_DOWNLOAD = "CAN_DOWNLOAD",
  // NOT_SET = "NOT_SET",
}
